export default "__VITE_ASSET__BUO0wo2c__"